import { useRef, useState, useEffect } from 'react';
import { Container, Button, TextField, Stack, Typography } from '@mui/material';
import LoadingButton from '@mui/lab/LoadingButton';
import { useNavigate, useParams } from 'react-router-dom';
import { toast } from 'react-toastify';

import UploadPreview from '../components/uploads/UploadPreview';
import { createEmployee, getEmployee, updateEmployee } from '../utils/requests/employeesRequest';

export default function AddEmployee() {
  /**
   * @type {string}
   */
  const [name, setName] = useState('');
  /**
   * @type {string}
   */
  const [role, setRole] = useState('');
  /**
   * @type {string|undefined}
   */
  const [currentPhoto, setCurrentPhoto] = useState();

  const { id } = useParams();

  const [nameError, setNameError] = useState(false);
  const [roleError, setRoleError] = useState(false);
  const [isSending, setIsSending] = useState(false);
  const [file, setFile] = useState();

  const navigate = useNavigate();

  const roleInput = useRef();
  const nameInput = useRef();

  useEffect(() => {
    if (!id) return;
    getEmployee(id).then((employee) => {
      setName(employee.name);
      setRole(employee.role);
      setCurrentPhoto(employee.photo);
    });
  }, [id]);

  const onFileChange = (e) => {
    setFile(e.target.files[0]);
  };

  const onSubmit = (e) => {
    e.preventDefault();
    setIsSending(true);
    sendRequest()
      .then((response) => {
        toast.success(response.data.message);
        navigate('../');
      })
      .catch((error) => {
        if (!error.response) return;
        const { data } = error.response;
        if (data.data.name) {
          setNameError(data.data.name[0]);
        }
        if (data.data.role) {
          setRoleError(data.data.role[0]);
        }
        if (data.data.photo) {
          toast.error(data.data.photo[0]);
        }
      })
      .finally(() => {
        setIsSending(false);
      });
  };

  const sendRequest = () => {
    if (id) {
      return updateEmployee(id, name, role, file);
    }
    return createEmployee(name, role, file);
  };

  return (
    <Container>
      <Typography variant="h4" sx={{ mb: 5 }}>
        {id ? 'Update employee' : 'Add new Employee'}
      </Typography>

      <form onSubmit={(e) => onSubmit(e)}>
        <Stack spacing={3}>
          <UploadPreview onChange={(e) => onFileChange(e)} currentPhoto={currentPhoto} />
          <TextField
            error={nameError}
            disable={isSending}
            helperText={nameError}
            fullWidth
            label="Name"
            value={name}
            onChange={(e) => setName(e.target.value)}
            inputRef={nameInput}
            type="text"
          />
          <TextField
            error={roleError}
            multiline
            disable={isSending}
            helperText={roleError}
            fullWidth
            minRows={3}
            value={role}
            onChange={(e) => setRole(e.target.value)}
            label="Description"
            inputRef={roleInput}
            type="text"
          />
          <Stack direction={{ xs: 'column', sm: 'row' }} spacing={2}>
            <LoadingButton loading={isSending} variant="contained" type="submit">
              {id ? 'Update' : 'Create'}
            </LoadingButton>
            <Button
              variant="text"
              type="button"
              disabled={isSending}
              onClick={() => navigate('../')}
            >
              Cancel
            </Button>
          </Stack>
        </Stack>
      </form>
    </Container>
  );
}
